/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ellipsis-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo } from 'react';
import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
import { fg } from '@atlaskit/platform-feature-flags';
import { Pressable } from '@atlaskit/primitives/compiled';
var noop = __noop;
var itemWrapperStyles = null;
var staticItemStyles = null;
var styles = {
  root: "_11c82smr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz131l _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj131l _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3131l _9h8h1fxt"
};
var EllipsisItem = /*#__PURE__*/memo(function (_ref) {
  var label = _ref.label,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("li", {
    className: ax(["_1e0c1txw _vchhusvi _p12f1osq _4t3i59ms _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"]),
    style: {
      "--_1fdrbou": ix("".concat(24 / 14, "em"))
    }
  }, fg('platform_dst_breadcrumbs_step_conversion') ? /*#__PURE__*/React.createElement(Pressable, {
    "aria-label": label,
    onClick: onClick,
    xcss: styles.root,
    testId: testId
  }, "\u2026") : /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle-link",
    "aria-label": label,
    onClick: onClick,
    spacing: "none",
    testId: testId,
    className: ax(["_1rjc1tvq _k48p1hhk _vwz41txs"])
  }, "\u2026"));
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default EllipsisItem;